
const GraphQLQuery = require('app/graphql/Query');
const AutocompleteList = require('app/ui/list/Autocomplete');

class TempForm {
    defaultOptions() {
        return {
            'title': "title",
            'suppliers': [],
            'ranges': [],
            'units': [],

            'autocompleteTriggerMinLength': 3,
            'nbAutocompleteResult': 10,
            'onSubmit': function(data){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onReferenceAutocomplete = this.onReferenceAutocomplete.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClickUnlinkProduct = this.onClickUnlinkProduct.bind(this);

        this.typingTimer=null;
        this.initialize();
    }

    initialize() {
        var self = this;


        this.build();
    }

    build(){
        this.buildForm();
    }

    buildForm(){
        var self = this;

        this.$form = $('<form/>')
        .addClass('restaurant-analyse-product-create-form')
        .on('submit',this.onSubmit);


        this.$inputReference = $('<input/>')
        .attr('type','text')
        .attr('id','reference')
        .attr('name','reference')
        .addClass('form-control')
        .attr('required',"required")
        .attr('aria-describedby','referenceHelper')
        .on('keydown',this.onReferenceAutocomplete)
        .on('keyup',this.onReferenceAutocomplete);

        this.$inputHiddenLinkedProduct = $('<input/>')
        .attr('type','hidden')
        .attr('name','linkedProduct')
        .val(0);
        this.$form.append(this.$inputHiddenLinkedProduct);

        this.$selectProductContainer = $('<div/>')
        .hide();

        this.$btnUnlink = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-text btn-dark')
        .attr('title',window.translate('app.restaurant.show.tabs.analyse.product.reference.unlink'))
        .append(
            $('<i/>')
            .addClass('fa fa-unlink')
        )
        .on('click',this.onClickUnlinkProduct);

        this.$form
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for','reference')
                .append(window.translate('restaurant.product.reference.label'))
            )
            .append(
                $('<div/>')
                .addClass('input-group')
                .append(this.$inputReference)
                .append(
                    $("<span/>")
                    .addClass('input-group-text')
                    .append(this.$btnUnlink)
                    .hide()
                )
            )
            .append(this.$selectProductContainer)
        )
        
        this.$selectProductUnit = $('<select/>')
        .attr('type','text')
        .attr('id','productUnit')
        .attr('name','productUnit')
        .attr('required',"required")
        .addClass('form-control');
        for(var i in this.settings.units){
            let unit = this.settings.units[i];

            this.$selectProductUnit.append(
                $('<option/>')
                .val(unit.value)
                .append(unit.label)
            );
        }
        let $unitFormGroup = $('<div/>')
        .addClass('form-group')
        .append(
            $('<label/>')
            .attr('for','productUnit')
            .append(window.translate('restaurant.prospect.product.unit.label'))
        )
        .append(this.$selectProductUnit);

        this.$inputProductQuantity = $('<input/>')
        .attr('type','text')
        .attr('id','productQuantity')
        .attr('name','productQuantity')
        .attr('required',"required")
        .addClass('form-control');
        
        let $quantityFormGroup = $('<div/>')
        .addClass('form-group')
        .append(
            $('<label/>')
            .attr('for','productQuantity')
            .append(window.translate('restaurant.prospect.product.quantity.label'))
        )
        .append(this.$inputProductQuantity);


        let $packaging = $('<div/>')
        .append(
            $('<label/>')
            .append(window.translate('restaurant.prospect.product.packaging.label'))
        )
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6')
                .append($quantityFormGroup)
            )
            .append(
                $('<div/>')
                .addClass('col-6 ps-2')
                .append($unitFormGroup)
            )
        )
        this.$form.append($packaging);
        
            
        this.$inputQuantity = $('<input/>')
        .attr('type','text')
        .attr('id','quantity')
        .attr('name','quantity')
        .attr('required',"required")
        .addClass('form-control');
        this.$form
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for','quantity')
                .append(window.translate('restaurant.prospect.invoice.quantity.label'))
            )
            .append(this.$inputQuantity)
        )
        
        
        this.$inputPrice = $('<input/>')
        .attr('type','text')
        .attr('id','price')
        .attr('name','price')
        .addClass('form-control')
        .attr('required',"required")
        .attr('aria-describedby','priceHelper');
        this.$priceHelper = $('<div/>')
        .attr('id','priceHelper')
        .addClass('form-text');
        this.$form
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for','price')
                .append(window.translate('restaurant.product.price.label'))
            )
            .append(this.$inputPrice)
            .append(this.$priceHelper)
        )


        this.$btnSubmit = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-success')
        .append(window.translate("add"))
        .on('click',this.onSubmit);


        let $btnCancel = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-text text-secondary')
        .append(window.translate("cancel"))
        .on('click',function(event){
            self.dispose(); 
        });
        

        this.$form.append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-2')
            .append(this.$btnSubmit)
            .append(' ')
            .append($btnCancel)
        );
        return this.$form;
    }

    dispose(){
        this.modal.dispose();
    }

    onSuccess(data){
        this.dispose();
        this.settings.onSuccess(data.productAssociation);
    }

    onReferenceAutocomplete(event){
        var self = this;
        let typingInterval = 500;
        if(this.typingTimer){
            clearTimeout(this.typingTimer);
        }
        this.typingTimer = setTimeout(
            function(){
                self.proceedAutocomplete();
            },
            typingInterval
        );
    }

    proceedAutocomplete(){
        this.$selectProductContainer.html('');

        let text = this.$inputReference.val();
        if(text.length >= this.settings.autocompleteTriggerMinLength){
            this.searchProduct(text);
        }

    }

    searchProduct(text){
        var self = this;

        if(this.autocompleteQuery){
            this.autocompleteQuery.abort();
        }

        this.$selectProductContainer.html('')
        .append(window.App.generateLoader())
        .show();


        let parameters = {
            'first': this.settings.nbAutocompleteResult,
            'filter': {
                'reference': '%'+text+'%'
            }
        };

        let fields = [
            'id',
            'reference',
            'unit',
            'quantity',
            'price',
            'supplierPrice',
            'supplier { name }',
            'range { id name parent { name } }',
        ];

        this.autocompleteQuery = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProducts',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                console.log("search data",data);
                self.showSearchProductResult(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        this.autocompleteQuery.execute();
    }

    showSearchProductResult(data){
        var self = this;
        this.$selectProductContainer.html('');
        this.unlinkProduct();
        let items = data.edges;

        this.autocompleteList = new AutocompleteList({
            '$container': this.$selectProductContainer,

            'listClass': 'restaurant-analyse-product-autocomplete-list',
            'listItemClass': 'restaurant-analyse-product-autocomplete-list-item',
            'messageNoItem': window.translate('app.restaurant.show.tabs.analyse.product.reference.noMatchFound'),

            'items': items,
            'renderItem': function(item){
                return self.buildSearchProductResultItem(item.node);
            },
            'onClickItem': function(item){ 
                return self.onClickProductResultItem(item.node);
            },
        });

    }

    clearSearchProductResult(){
        this.$selectProductContainer.html('');
    }

    buildSearchProductResultItem(product){
        var self = this;

        let reference = product.reference;
        let price = product.price;
        let quantity = product.quantity;
        let rangeName = product.range.name;
        let parentRangeName = product.range && product.range.parent ? product.range.parent.name : '';
        let supplierPrice = product.supplierPrice;
        let supplierName = product.supplier.name;
        let unit = product.unit;

        let parentRangeLabel = parentRangeName ? '('+parentRangeName+')' : '';

        let $content = $('<div/>')
        .addClass('row')
        .append(
            $('<div/>')
            .addClass('col-4')
            .append(reference)
        )
        .append(
            $('<div/>')
            .addClass('col-4')
            .append(
                $('<div/>')
                .append(rangeName)
            )
            .append(
                $('<div/>')
                .append(parentRangeLabel)
            )
        )
        .append(
            $('<div/>')
            .addClass('col-2')
            .append(
                $('<div/>')
                .append('CBS')
            )
            .append(
                $('<div/>')
                .append(window.formatFloat(quantity) + unit)
            )
        )
        .append(
            $('<div/>')
            .addClass('col-2')
            .append(
                $('<div/>')
                .append('P.A. : ' + window.formatFloat(price) + ' &euro;')
            )
            .append(
                $('<div/>')
                .append('P.V. : ' + window.formatFloat(supplierPrice) + ' &euro;')
            )
        )

        return $content;
    }

    onClickProductResultItem(product){
        this.clearSearchProductResult();
        this.$inputHiddenLinkedProduct.val(product.id);
        this.$btnUnlink.parent().show();

        this.$inputReference.val(window.htmldecode(product.reference));
        $('option[value="'+product.unit+'"]',this.$selectProductUnit).prop('selected',true);
        this.$inputProductQuantity.val(product.quantity);
        this.$priceHelper
        .html('')
        .append('P.V. Restofuté : ' + this.getPriceByUnit(product.unit,product.quantity,product.supplierPrice));
    }

    getPriceByUnit(unit,cond,price){

        let floatCond = parseFloat(cond);
        let floatPrice = parseFloat(price);

        if(floatCond <= 0){
            return 0;
        }

        let conditionnement = floatCond > 1 ? window.formatFloat(floatCond) + ' ' + unit : unit;
        return window.formatFloat(floatPrice)+' &euro; / '+ conditionnement;
    }

    onClickUnlinkProduct(){
        this.unlinkProduct();
    }

    unlinkProduct(){
        this.$inputHiddenLinkedProduct.val(0);
        this.$btnUnlink.parent().hide();
        this.$priceHelper.html('');
    }


    isValid(){
        var formObject = this.$form[0];
        var validity = formObject.checkValidity();
        this.$form.addClass('was-validated');

        if(validity === false){
            return false;
        }
        return true;
    }

    onSubmit(event){
        event.preventDefault();
        event.stopPropagation();
        if(!this.isValid()){
            return;
        }

        let data = window.serializeForm(this.$form);

        this.settings.onSubmit(data);
        if(this.settings.onSubmitDispose){
            this.dispose();
        }
    }
}

module.exports = TempForm;

